import { CREATE_CATEGORY, DELETE_CATEGORY, EDIT_CATEGORY, LIST_CATEGORY, VIEW_CATEGORY } from "./types";


export const createCategoryAction = (data, onSuccess, onError) => {
    return {
        type: CREATE_CATEGORY,
        data,
        onSuccess,
        onError,
    };
};

export const editCategoryAction = (data, onSuccess, onError) => {
    return {
        type: EDIT_CATEGORY,
        data,
        onSuccess,
        onError,
    };
};

export const listCategoryAction = (data, onSuccess, onError) => {
    return {
        type: LIST_CATEGORY,
        data,
        onSuccess,
        onError,
    };
};

export const viewCategoryAction = (data, onSuccess, onError) => {
    return {
        type: VIEW_CATEGORY,
        data,
        onSuccess,
        onError,
    };
};

export const deleteCategoryAction = (data, onSuccess, onError) => {
    return {
        type: DELETE_CATEGORY,
        data,
        onSuccess,
        onError,
    };
};